import React, {FC, useEffect, useState} from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import './datatables.scss';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import {useDispatch, useSelector} from 'react-redux';
import {getEngineersSelector} from '../../selectors/engineer';
import {EngineerList} from '../../components/Engineer/EngineerList';
import {getEngineers} from '../../store/engineers/actions';
import {createLoadingSelector} from '../../selectors/loading';
import {GET_ENGINEERS} from '../../store/engineers/actionTypes';

const EngineersOverview: FC = () => {
  const engineers = useSelector(getEngineersSelector);
  const dispatch = useDispatch();

  const engineersLoadingSelector = useSelector(
      createLoadingSelector([GET_ENGINEERS]),
  );
  const [engineersLoading, setEngineersLoading] = useState(true);

  useEffect(() => {
    dispatch(getEngineers());
  }, [dispatch]);

  useEffect(() => {
    setEngineersLoading(engineersLoadingSelector);
  }, [engineersLoadingSelector]);

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Members" breadcrumbItem="Overview"/>
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <EngineerList
                  engineers={engineers}
                  isLoading={engineersLoading}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default EngineersOverview;
